/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class PaymentConfigurationService extends services.DataService<Wars.Domain.Model.Payment.PaymentConfiguration> {
        private logType: string = "PaymentConfigurationService";


        constructor(injectedBreeze: typeof breeze, $q: angular.IQService, private $http:angular.IHttpService) {
            super(injectedBreeze, $q);
        }

        public createNewPaymentConfig(): Wars.Domain.Model.Payment.PaymentConfiguration {
            var newPaymentConfig = this.createNewEntity<Wars.Domain.Model.Payment.PaymentConfiguration>("PaymentConfiguration");
            newPaymentConfig.showReceiptPage = false;

            var paymentAmountMapping = this.createNewEntity<Wars.Domain.Model.Payment.PaymentInfoToFormProcessDataMapping>("PaymentInfoToFormProcessDataMapping");
            paymentAmountMapping.paymentConfiguration_id = newPaymentConfig.id;
            paymentAmountMapping.isPaymentAmount = true;
            paymentAmountMapping.isPaymentDate = false;
            paymentAmountMapping.isPaymentUserId = false;


            var paymentDateMapping = this.createNewEntity<Wars.Domain.Model.Payment.PaymentInfoToFormProcessDataMapping>("PaymentInfoToFormProcessDataMapping");
            paymentDateMapping.paymentConfiguration_id = newPaymentConfig.id;
            paymentDateMapping.isPaymentAmount = false;
            paymentDateMapping.isPaymentDate = true;
            paymentDateMapping.isPaymentUserId = false;

            var paymentUserIdMapping = this.createNewEntity<Wars.Domain.Model.Payment.PaymentInfoToFormProcessDataMapping>("PaymentInfoToFormProcessDataMapping");
            paymentUserIdMapping.paymentConfiguration_id = newPaymentConfig.id;
            paymentUserIdMapping.isPaymentAmount = false;
            paymentUserIdMapping.isPaymentDate = false;
            paymentUserIdMapping.isPaymentUserId = true;

            newPaymentConfig.myMappings.push(paymentAmountMapping, paymentDateMapping, paymentUserIdMapping);

            return newPaymentConfig;
        }

        public isCompleteAndValid(paymentConfiguration: Wars.Domain.Model.Payment.PaymentConfiguration): Array<string> {
            return [];
        }

        public createNewCustomInfo(paymentConfigId: string): Wars.Domain.Model.Payment.PaymentCustomInformation {
            var newCustomInfo = this.createNewEntity<Wars.Domain.Model.Payment.PaymentCustomInformation>("PaymentCustomInformation");
            newCustomInfo.paymentConfiguration_id = paymentConfigId;

            var customInfoMapping = this.createNewEntity<Wars.Domain.Model.Payment.PaymentInfoToFormProcessDataMapping>("PaymentInfoToFormProcessDataMapping");
            customInfoMapping.paymentConfiguration_id = paymentConfigId;
            customInfoMapping.customInfo = newCustomInfo;
            customInfoMapping.customInfo_id = newCustomInfo.id;
            customInfoMapping.isPaymentAmount = false;
            customInfoMapping.isPaymentDate = false;
            customInfoMapping.isPaymentUserId = false;

            return newCustomInfo;
        }
    }
}

warsApp.registerService('PaymentConfigurationService', ['breeze', '$q', '$http']);